<template>
  <nav class="navbar">
    <div class="left">
      <button class="button arrow-container" slot="left" type="button" @click="goBackHandler">
        <i class="material-icons">chevron_left</i>
      </button>
    </div>

    <div class="title">
      <span>{{ title }}</span>
    </div>

    <div class="right">
      <slot name="right"></slot>
    </div>
  </nav>
</template>

<script lang="babel">
import SignupRouteMixin from "@/mixins/SignupRouteMixin";

export default {
  name: 'Navbar',
  // FIXME: NavbarのgoBackを完全にsignup用にしていいのか
  mixins: [ SignupRouteMixin ],
  props: {
    title: {
      type: String,
      required: false
    },
    onGoBack: {
      type: Function,
      required: false
    }
  },
  methods: {
    goBackHandler() {
      this.onGoBack ? this.onGoBack(this.goBack) : this.goBack();
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  box-sizing: inherit;
  left: 0;
  top: 0;
  height: 60px;
  margin-right: 16px;
  margin-left: 16px;
  padding: 8px 0;
  background: white;
  justify-content: space-between;

  .button {
    background: white;
    border: none;
    padding: 0;
    .material-icons {
      font-size: 40px;
      color: #F94848;
    }
  }
  .arrow-container {
    margin-left: -8px; // アイコンのスペース補正用
  }
}

.left, .right {
  width: 20%;
  height: 100%;
  box-sizing: inherit;
  display: flex;
  align-items: center;
}

.left {
}

.right {
  justify-content: flex-end;
}

.title {
  width: 60%;
  height: 100%;

  font-weight: 500;
  font-size: 16px;
  line-height: 22px;

  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
